var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:(_vm.handleStyle)},[_c('div',[_c('video',{attrs:{"muted":"","autoplay":"","src":_vm.videoSrc},domProps:{"muted":true}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }